import { render, staticRenderFns } from "./DataBinding.vue?vue&type=template&id=8454cd02&"
import script from "./DataBinding.vue?vue&type=script&lang=js&"
export * from "./DataBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports